/* unplugin-vue-components disabled */import { render } from "./Waves.vue?vue&type=template&id=6d37035d"
import script from "./Waves.vue?vue&type=script&lang=js"
export * from "./Waves.vue?vue&type=script&lang=js"

import "./Waves.vue?vue&type=style&index=0&id=6d37035d&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__